<template>
  <v-container class="ma-0" style="max-width: unset">
    <v-row>
      <v-col class="px-0" cols="7">
        <p class="mb-2 select-label"
           v-if="userCompareGroups.length > 0">
          Meine Vergleichsgruppen
        </p>
        <v-select class="mb-3"
                  dense
                  hide-details
                  label="eigene Vergleichsgruppen"
                  outlined
                  style="max-width: 420px;"
                  v-if="userCompareGroups.length > 0"
                  v-model="selectedGroup"
        />

        <p class="mt-5 cg-info">Wähle hier ganz individuell eine oder mehrere Unternehmen mit denen du
          deine Aktie vergleichen möchtest.</p>

        <fin-assets-name-isin-autocomplete :custom-return-item="customReturnShareItem"
                                           instant-clear-selection
                                           style="max-width: 420px;"
                                           @input="(val) => addNewShare(val)"/>
      </v-col>
      <v-col cols="5">
        <v-img :max-width="221" :src="require('@/assets/tools/tool-empty-state.svg')" contain/>
      </v-col>
    </v-row>
    <v-row v-if="customCompGroupShares.length > 0">
      <v-col>
        <fin-data-table :headers="tableHeaders"
                        :height="540"
                        :resolver="customCompGroupShares"
                        class="mt-2"
                        fixed-header
                        shrink-to-view-port
                        sticky-first-col
                        sticky-last-col
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col align="right">
        <v-btn class="mr-4"
               @click="$router.push({ name: 'finToolsRateShares'})"
               v-if="!sector">
          Zurück zur Aktien-Suche
        </v-btn>

        <v-btn class="mr-4"
               text
               v-if="sector"
               @click="comingSoon">
          Vergleichsgruppe speichern
          <v-icon class="ml-1">icon-save</v-icon>
        </v-btn>

        <v-btn dark
               @click="comingSoon">
          Anwenden
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FinAssetsNameIsinAutocomplete from "@/components/common/AssetsNameIsinAutocomplete"
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"

export default {
  name: "finCustomGroupTab",
  components: {FinAssetsNameIsinAutocomplete, FinDataTable},
  props: {
    selectedShares: {
      type: Array,
      default: () => []
    },
    sector: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      customCompGroupShares: this.selectedShares,
      userCompareGroups: [],
      selectedGroup: null,
    }
  },
  computed: {
    tableHeaders() {
      const actions = [{
        name: 'Löschen',
        icon: 'icon-delete',
        iconOnly: true,
        click: this.deleteCustomGroupShare
      }]

      return TablePresets.createShareRatingHeaders(actions)
    },
    customReturnShareItem() {
      return 'id isin assetClass name close closeDate peRatio pcfRatio pRevenueRatio pBVRatio evEBITDARatio evRevenueRatio currency countryCode gicsCode country { name alpha2Code }'
    }
  },
  methods: {
    addNewShare(share) {
      if (this.customCompGroupShares.find(sh => sh.id === share.id) === undefined) {
        this.customCompGroupShares.push(share)
      }
    },
    deleteCustomGroupShare(share) {
      this.$confirm({
        title: 'Aktie löschen',
        text: 'Möchtest du ' + share.name + ' wirklich aus deiner Vergleichsgruppe löschen?',
        confirmBtn: 'Löschen',
        textWithLexikonLink: false,
        cancelBtn: 'Abbrechen'
      }).then(() => {
        this.customCompGroupShares = this.customCompGroupShares.filter(cs => cs.id !== share.id)
      })
    },
    comingSoon() {
      this.$toasted.global.finToast({
        message: 'An dieser Funktionalität arbeiten wir gerade noch mit Hochdruck :)',
        type: 'info',
      })
      this.$emit('closeCompareGroupMode')
    }
  },
  watch: {
    selectedShares() {
      this.customCompGroupShares = this.selectedShares
    }
  }
}
</script>

<style scoped>

</style>
